import dynamic from 'next/dynamic';
import { CompProps } from './ConfirmChangesModal.types';

export const ConfirmChangesModal = dynamic<CompProps>(() =>
  import('./ConfirmChangesModal').then(module => module.ConfirmChangesModal)
);
